import React from 'react';

type FillColor = string;
type ClassName = string;

interface Props {
  fillColor: FillColor;
  className: ClassName;
}

const defaultProps = {
  className: '',
  fillColor: '#53585E',
};

const DistributionNetworkIcon = ({
  fillColor,
  className,
}: Props): React.ReactElement<React.ReactNode> => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 35.6 40"
    className={className}
  >
    <g>
      <g>
        <g>
          <g>
            <path
              className="st0"
              d="M17,10.8h1.7V6.6c0.6-0.1,1.1-0.4,1.5-0.9c1.3-1.3,1.3-3.4,0-4.7c-1.3-1.3-3.4-1.3-4.7,0s-1.3,3.4,0,4.7 c0.4,0.4,1,0.7,1.5,0.9V10.8z M16.6,4.5c0.7,0.7,1.7,0.7,2.4,0s0.7-1.7,0-2.4s-1.7-0.7-2.4,0S16,3.9,16.6,4.5z M25.4,14.7 l0.8,1.4l3.7-2.1c0.4,0.4,0.9,0.7,1.5,0.9c1.8,0.5,3.6-0.6,4.1-2.4s-0.6-3.6-2.4-4.1C31.4,8,29.6,9,29.1,10.8 c-0.2,0.6-0.1,1.2,0,1.8L25.4,14.7z M26.2,23.9l-0.8,1.4l3.7,2.1c-0.2,0.6-0.2,1.2,0,1.8c0.5,1.8,2.3,2.8,4.1,2.4 c1.8-0.5,2.8-2.3,2.4-4.1c-0.5-1.8-2.3-2.8-4.1-2.4c-0.6,0.2-1.1,0.5-1.5,0.9L26.2,23.9z M18.7,29.2H17v4.3 c-0.6,0.1-1.1,0.4-1.5,0.9c-1.3,1.3-1.3,3.4,0,4.7s3.4,1.3,4.7,0c1.3-1.3,1.3-3.4,0-4.7c-0.4-0.4-1-0.7-1.5-0.9V29.2z M10.3,25.3l-0.8-1.4L5.7,26c-0.4-0.4-0.9-0.7-1.5-0.9c-1.8-0.5-3.6,0.6-4.1,2.4c-0.5,1.8,0.6,3.6,2.4,4.1 C4.3,32,6.1,31,6.6,29.2c0.2-0.6,0.1-1.2,0-1.8L10.3,25.3z M9.5,16.1l0.8-1.4l-3.7-2.1c0.2-0.6,0.2-1.2,0-1.8 C6.1,9,4.3,8,2.5,8.4c-1.8,0.5-2.8,2.3-2.4,4.1s2.3,2.8,4.1,2.4c0.6-0.2,1.1-0.5,1.5-0.9L9.5,16.1z M30.7,11.2 c-0.2,0.9,0.3,1.8,1.2,2c0.9,0.2,1.8-0.3,2-1.2c0.2-0.9-0.3-1.8-1.2-2S30.9,10.3,30.7,11.2z M31.9,26.7 c-0.9,0.2-1.4,1.2-1.2,2s1.2,1.4,2,1.2c0.9-0.2,1.4-1.2,1.2-2C33.7,27,32.8,26.5,31.9,26.7z M19,35.5c-0.7-0.7-1.7-0.7-2.4,0 s-0.7,1.7,0,2.4c0.7,0.7,1.7,0.7,2.4,0C19.7,37.2,19.7,36.1,19,35.5z M5,28.8c0.2-0.9-0.3-1.8-1.2-2c-0.9-0.2-1.8,0.3-2,1.2 s0.3,1.8,1.2,2C3.8,30.2,4.7,29.7,5,28.8z M3.8,13.3c0.9-0.2,1.4-1.2,1.2-2c-0.2-0.9-1.2-1.4-2-1.2s-1.4,1.2-1.2,2 C2,13,2.9,13.5,3.8,13.3z"
              fill={fillColor}
            />
          </g>
        </g>
        <ellipse
          className="st1"
          cx="18"
          cy="19.7"
          rx="8.3"
          ry="8.1"
          fill="transparent"
          stroke={fillColor}
        />
      </g>
    </g>
  </svg>
);

DistributionNetworkIcon.defaultProps = defaultProps;

export default DistributionNetworkIcon;
